<script lang="ts" setup>
import { Collapse } from 'bootstrap';
import { onMounted, ref } from 'vue';

const props = defineProps<{
    title: string;

    /**
     * If true, the accordion item is collapsed by default
     */
    collapsed?: boolean;
}>();

let collapseInstance: Collapse | null = null;
const collapse = ref<HTMLDivElement | null>(null);

/**
 * Keep the collapse state
 */
const isCollapsed = ref<boolean>(props.collapsed ?? false);

/**
 * Toggle collapse state of the accordion item
 */
const toggle = () => {
    isCollapsed.value = !isCollapsed.value;
    collapseInstance?.toggle();
};

onMounted(() => {
    collapseInstance = Collapse.getOrCreateInstance(collapse.value!);
});
</script>
<template>
    <div class="accordion-item">
        <h2 class="accordion-header">
            <div
                type="button"
                class="accordion-button px-3 py-3 no-focus"
                :class="{ collapsed: isCollapsed }"
                @click="toggle"
            >
                <div class="d-flex w-100 gap-3">
                    <span class="flex-fill fs-5">{{ $tm(props.title) }}</span>

                    <!-- Here we can put other components in the header -->
                    <div class="d-flex gap-2 align-items-center" @click.stop @mousedown.stop">
                        <slot
                            name="header"
                            @click.stop
                            @mousedown.stop
                        ></slot>
                    </div>
                </div>
            </div>
        </h2>
        <div
            ref="collapse"
            class="accordion-collapse"
        >
            <div class="accordion-body p-0 p-3">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
